import SelectField from "../common/SelectField";
import SearchBar from "../common/SearchBar";
import "../../styles/common.css";
import "../../styles/driverHeader.css";
import "../../styles/driver_modal.css";
import { Car, CheckCircle, Plus } from "lucide-react";


export default function CarHeader({ total, search, onSearch, approveFilter, onApproveChange, onAdd }) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <Car size={24} className="primaryIcon" />
            <h2>Véhicules Clients</h2>
          </div>
          <span className="countBadge">{total} véhicules</span>
        </div>
        
        {/* <button className="btnPrimary" onClick={onAdd}>
          Ajouter un véhicule
          <Plus size={18} style={{ marginLeft: '8px' }} />
        </button> */}
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
          <SelectField
            icon={CheckCircle}
            value={approveFilter}
            onChange={onApproveChange}
            options={[
              { label: "Tous les véhicules", value: "all" },
              { label: "Approuvés", value: "approved" },
              { label: "En attente", value: "pending" },
            ]}
          />
        </div>
        <div className="searchWrapper">
          <SearchBar 
            value={search} 
            onChange={onSearch} 
            placeholder="Matricule, Marque, Propriétaire..." 
          />
        </div>
      </div>
    </div>
  );
}
